var _circle, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgProfile = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 41,
  height: 41,
  viewBox: "0 0 41 41",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 20.5,
  cy: 20.5,
  r: 20.5,
  transform: "rotate(-180 20.5 20.5)",
  fill: "#0F8EB3"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30.6951 29.235C28.1114 26.6228 24.525 25.0044 20.5606 25.0044C16.5337 25.0044 12.8969 26.6743 10.3047 29.3593",
  fill: "#0F8EB3"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M30.6951 29.235C28.1114 26.6228 24.525 25.0044 20.5606 25.0044C16.5337 25.0044 12.8969 26.6743 10.3047 29.3593",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M20.4115 21.4409C23.1176 21.4409 25.3113 19.2472 25.3113 16.5411C25.3113 13.8351 23.1176 11.6414 20.4115 11.6414C17.7054 11.6414 15.5117 13.8351 15.5117 16.5411C15.5117 19.2472 17.7054 21.4409 20.4115 21.4409Z",
  fill: "#0F8EB3",
  stroke: "white",
  strokeWidth: 1.5
})));

const ForwardRef = /*#__PURE__*/forwardRef(SvgProfile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/profile.939d5cb51ffbb8960f768cb03da8fe35.svg";